import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/spinner.svg'
import _imports_1 from '@/assets/images/remove-member.svg'


const _hoisted_1 = { class: "team-members-item-body" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "list-item-name" }
const _hoisted_4 = {
  key: 0,
  class: "chip"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "list-item-spacer" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "spinner",
  src: _imports_0
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonElement = _resolveComponent("ButtonElement")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["team-members-item", _ctx.memberItemChipClass])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("img", {
          src: _ctx.member.profile_picture_url
        }, null, 8, _hoisted_2)
      ]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.member.name), 1),
      (_ctx.chipText !== '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.chipText), 1))
        : _createCommentVNode("", true),
      _hoisted_5,
      (_ctx.isEditing)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.loadingCancelPendingInvite || _ctx.loadingKickMember)
              ? (_openBlock(), _createElementBlock("img", _hoisted_6))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (!_ctx.isLive)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "remove-member",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.kickMemberFromTeam()))
                      }, _hoisted_8))
                    : _createCommentVNode("", true)
                ], 64))
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.inviteOnClick)
        ? (_openBlock(), _createBlock(_component_ButtonElement, {
            key: 2,
            theme: "outline-light",
            type: "button",
            loading: _ctx.loadingInviteUser,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.doInvite()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('modals.search_users.invite')), 1)
            ]),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}